import type { SwellsTimestep } from 'types/swell';
import type { WaveEnergyGraphData } from 'types/waveEnergy';

export function hasDisplayableWaveEnergyForDayIndices(
  waveEnergy: WaveEnergyGraphData | undefined,
  dayIndices: number[],
): boolean {
  if (waveEnergy === undefined || waveEnergy.loading || waveEnergy.error || !waveEnergy.days) {
    return false;
  }
  return dayIndices.flatMap((d) => waveEnergy.days?.[d] ?? []).length > 0;
}

export function getNearshoreKjForSwellHour(
  waveEnergy: WaveEnergyGraphData,
  dayIndex: number,
  swellHour: SwellsTimestep,
): number | undefined {
  const daySteps = waveEnergy.days?.[dayIndex];
  if (!daySteps?.length) return undefined;
  const match = daySteps.find(
    (step) => step.timestamp === swellHour.timestamp && step.utcOffset === swellHour.utcOffset,
  );
  if (match && typeof match.nearshore === 'number') {
    return match.nearshore;
  }
  return undefined;
}
